import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';
import { top } from '../../../utils/customPropStyles';
const StyledComponent = styled<any, any>(
    'div',
    'styledComponent',
    'autocomplete'
)`
    ${propStyles};
    ${top};
`;
StyledComponent.defaultProps = {
    position: 'absolute',
    top: 'calc(100% + 1px)',
    left: '0',
    right: '0',
    zIndex: 'dropdown',
    bgColor: 'white',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
    boxShadow: 'sm',
};
export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Autocomplete/StyledComponents/Dropdown.tsx